
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Portabilty_Afso from "./Portabilty_Afso";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

function PortabilityDistrictTable({ selectedMonth, selectedYear, onDataLoaded }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const detailsRRef = useRef(null);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [renderContent, setRenderContent] = useState(null);

  const nextTableRef = useRef(null);
  const currentTableRef = useRef(null);

  useEffect(() => {
    setRenderContent(null);
    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_URL_SIDE}/PortabilityAbstract/Portabilty_District`,
        { month: selectedMonth, year: selectedYear }
      )
      .then((response) => {
        setLoading(false);

        if (response.data.message) {
          setMessage(response.data.message);
          setData([]);
          if (onDataLoaded) onDataLoaded();
        } else {
          setTitle(response.data.title);
          setData(response.data.data || []);
          setMessage("");
        }
      })
      .catch((error) => {
        setError(error);

        console.error("Error fetching data", error);
        setLoading(false);
      });
  }, [selectedMonth, selectedYear]);

  const schemeHeaders = data.length > 0 ? data[0].schemeList || [] : [];

  const calculateSchemeTotals = (schemeId) => {
    return data.reduce(
      (sum, row) => {
        const found = row.schemeList?.find((s) => s.scheme_id === schemeId);

        return {
          avail_cards: sum.avail_cards + (found?.avail_cards || 0),
          avail_trans: sum.avail_trans + (found?.avail_trans || 0),
          avail_port_cards: sum.avail_port_cards + (found?.avail_port_cards || 0),
          avail_port_trans: sum.avail_port_trans + (found?.avail_port_trans || 0),
        };
      },
      {
        avail_cards: 0,
        avail_trans: 0,
        avail_port_cards: 0,
        avail_port_trans: 0,
      }
    );
  };

  const onDistrictClick = (distCode) => {
    setRenderContent(
      <div ref={nextTableRef}>
        <Portabilty_Afso
          distCode={distCode}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
        />
      </div>
    );
  };


  useEffect(() => {
    if (!loading && data.length > 0 && currentTableRef.current) {
        currentTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, data]);

  // ================= GRAND TOTALS =================
  const total_cards = data.reduce((sum, row) => sum + (row.total_cards || 0), 0);
  const totalAvailCards = data.reduce((sum, row) => sum + (row.avail_cards || 0), 0);
  const totalAvailTrans = data.reduce((sum, row) => sum + (row.avail_trans || 0), 0);
  const totalPortCards = data.reduce((sum, row) => sum + (row.avail_port_cards || 0), 0);
  const totalPortTrans = data.reduce((sum, row) => sum + (row.avail_port_trans || 0), 0);

  const totalAvailPercent = totalPortCards
    ? ((totalPortCards * 100) / totalAvailCards).toFixed(2)
    : "0.00";

  // const totalPortPercent = totalPortTrans
  //   ? ((totalPortCards * 100) / totalPortTrans).toFixed(2)
  //   : "0.00";


  const handleDownload = () => {
    const tableSelect = document.getElementById('distReport');
    if (!tableSelect) return;
    const dataType = 'application/vnd.ms-excel';
    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    downloadLink.download = 'sale_dist.xls';
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Box>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  return (
    <div>
      {data.length > 0 ? (
        <table border={1} align="center" id='distReport' width="95%" ref={currentTableRef}>

          <thead>
            <tr className="tableheader">
              <th colSpan={8 + schemeHeaders.length * 4}>{title}</th>
            </tr>

            <tr className="tableheader">
              <th rowSpan={3}>Sl.No</th>
              <th rowSpan={3}>District</th>
              <th rowSpan={3}>Total Cards</th>

              {schemeHeaders.map((sch, idx) => (
                <th key={idx} colSpan={4}>
                  {sch.scheme_short_name}
                </th>
              ))}

              <th colSpan={4}>TOTAL</th>

              <th rowSpan={3}>% ( Port Cards /Avail Cards )</th>
            </tr>

            <tr className="tableheader">
              {schemeHeaders.map((_, idx) => (
                <React.Fragment key={idx}>
                  <th colSpan={2}>Regular</th>
                  <th colSpan={2}>Portability</th>
                </React.Fragment>
              ))}

              <th colSpan={2}>Regular</th>
              <th colSpan={2}>Portability</th>
            </tr>

            <tr className="tableheader">
              {schemeHeaders.map((_, idx) => (
                <React.Fragment key={idx}>
                  <th>Avail Cards</th>
                  <th>Avail Trans</th>
                  <th>Port Cards</th>
                  <th>Port Trans</th>
                </React.Fragment>
              ))}

              <th>Avail Cards</th>
              <th>Avail Trans</th>
              <th>Port Cards</th>
              <th>Port Trans</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td
                  onClick={() => onDistrictClick(row.dist_code)}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  <u>{row.dist_name_en}</u>
                </td>

                <td style={{ textAlign: "right" }}>{row.total_cards || 0}</td>

                {schemeHeaders.map((sch, idx) => {
                  const found = row.schemeList?.find(
                    (s) => s.scheme_id === sch.scheme_id
                  );

                  return (
                    <React.Fragment key={idx}>
                      <td style={{ textAlign: "right" }}>{found?.avail_cards || 0}</td>
                      <td style={{ textAlign: "right" }}>{found?.avail_trans || 0}</td>
                      <td style={{ textAlign: "right" }}>{found?.avail_port_cards || 0}</td>
                      <td style={{ textAlign: "right" }}>{found?.avail_port_trans || 0}</td>
                    </React.Fragment>
                  );
                })}

                <td style={{ textAlign: "right" }}>{row.avail_cards || 0}</td>
                <td style={{ textAlign: "right" }}>{row.avail_trans || 0}</td>

                <td style={{ textAlign: "right" }}>{row.avail_port_cards || 0}</td>

                <td style={{ textAlign: "right" }}>{row.avail_port_trans || 0}</td>

                <td style={{ textAlign: "right" }}>
                  {row.avail_cards
                    ? ((row.avail_port_cards * 100) / row.avail_cards).toFixed(2)
                    : "0.00"}
                </td>

                {/* <td style={{ textAlign: "right" }}>
                  {row.avail_port_trans
                    ? ((row.avail_port_cards * 100) / row.avail_port_trans).toFixed(2)
                    : "0.00"}
                </td> */}
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="tableheader">
              <th colSpan={2}>Total</th>
              <th style={{ textAlign: "right" }}>{total_cards}</th>

              {schemeHeaders.map((sch, idx) => {
                const schemeTotal = calculateSchemeTotals(sch.scheme_id);

                return (
                  <React.Fragment key={idx}>
                    <th>{schemeTotal.avail_cards}</th>
                    <th>{schemeTotal.avail_trans}</th>
                    <th>{schemeTotal.avail_port_cards}</th>
                    <th>{schemeTotal.avail_port_trans}</th>
                  </React.Fragment>
                );
              })}

              <th>{totalAvailCards}</th>
              <th>{totalAvailTrans}</th>

              <th>{totalPortCards}</th>

              <th>{totalPortTrans}</th>


              <th>{totalAvailPercent}</th>
              {/* <th>{totalPortPercent}</th> */}
            </tr>

            <tr align="center">
              <td colSpan={7 + schemeHeaders.length * 4 + 2}>
                <button className="button button2" onClick={handleDownload}>
                  Export to Excel
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      ) : (
        <div class="mainhead" align="center">{message}</div>
      )}

      <br />
      {renderContent}
    </div>
  );
}

export default PortabilityDistrictTable;